<template>
  <div>
    <v-dialog v-model="preRegisterDialog" width="400px">
      <v-card>
        <v-card-title>
          <b>Pre-registration</b>
        </v-card-title>
        <v-card-text class="px-3 py-2">{{preRegisterStatusText}}</v-card-text>
        <br />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined small @click="preRegisterDialog = false" :color="dialogButtonColor">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <header class="container-fluid af-header cs-header">
      <div class="row">
        <div class="col col-headline">
          <h1>
            <span class="h-small">accelerating the</span>
            <span class="h-med">freight</span>
            <span class="h-btm">industry</span>
          </h1>
          <p class="col-para">
            <span>We are sorry, this page is still under construction.</span>
            <br />If you're interested to find out more, please pre-register with us. One of our representatives will get back to you as soon as possible.
          </p>
          <!-- <div class="preregister">
            <input
              type="text"
              v-validate="'required|email'"
              name="email"
              placeholder="Enter your email"
              style="width: 250px;"
              v-model="email"
            >
            <button class="header-btn" @click="onPreRegister" :disabled="registerDisabled">
              Pre-register now
              <i class="fas fa-long-arrow-alt-right"></i>
            </button>
            <span class="error-message">{{ errors.first('email') }}</span>
          </div>-->
        </div>
        <div class="col header-img comingsoon">
          <img src="@/assets/under-construction.png" alt />
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import axios from "axios";
import constant from "../../const";

export default {
  data() {
    return {
      email: null,
      preRegisterDialog: false,
      preRegisterStatusText: null,
      dialogButtonColor: "success"
    };
  },

  methods: {
    // onPreRegister(){
    //     var response = null
    //     axios.post( constant.API_HOST + '/pre-register?email=' + this.email)
    //     .then(resp => ( response = resp))
    //     .catch(err => { response = err.response })
    //     .finally(() => {
    //         if(response != null && response.status == constant.RESPONSE_STATUS_OK){
    //             this.preRegisterStatusText = 'Thank you for interest, your e-mail was successfully registered. Our customer service will reach out to you soon.'
    //             this.dialogButtonColor = 'success'
    //         }
    //         else{
    //             this.preRegisterStatusText = 'There was a problem registering your e-mail. Do reach out to us at info@accelefreight.com for further inquiries.'
    //             this.dialogButtonColor = 'red darken-4'
    //         }
    //         this.preRegisterDialog = true
    //     })
    // }
  },

  computed: {
    registerDisabled: {
      get() {
        return this.fields.email && !this.fields.email.valid;
      }
    }
  }
};
</script>

<style scoped>
input[type="text"] {
  text-align: left;
  width: 100%; /*Desired width*/
  height: 40px; /*Desired height*/
  border: 1px solid #cfd8dc;
  border-radius: 4px;
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 10px;
}

.header-btn {
  border: 1px solid #b8b8b8;
  background-color: #eceff1;
  height: 42px;
  padding: 0px 20px 0px 20px !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 0px;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  -ms-border-radius: 0px;
  -o-border-radius: 0px;
  transition: all ease-in 300ms;
  -webkit-transition: all ease-in 300ms;
  -moz-transition: all ease-in 300ms;
  -ms-transition: all ease-in 300ms;
  -o-transition: all ease-in 300ms;
  display: inline-block;
  text-align: center;
  min-width: 160px;
}

.header-btn i {
  margin-left: 5px;
  transition: all ease-in-out 120ms;
  -webkit-transition: all ease-in-out 120ms;
  -moz-transition: all ease-in-out 120ms;
  -ms-transition: all ease-in-out 120ms;
  -o-transition: all ease-in-out 120ms;
}

.header-btn:disabled {
  border-color: grey;
  color: grey;
}

.header-btn:hover:enabled {
  text-decoration: none;
  border-color: #1c6cf2;
  color: #1c6cf2;
}

.header-btn:hover:enabled i {
  margin-left: 10px;
}

.error-message {
  font-size: 80%;
  color: red;
  padding-left: 10px;
}
</style>
